// src/config.js
import API_ENDPOINTS, { pollJobStatus } from './apiConfig';

// Detect environment
const hostname = window.location.hostname;
const isAzureStaticApps = hostname.endsWith('azurestaticapps.net');
const isStaging = isAzureStaticApps && hostname.includes('-staging.');
const isProduction =
  (hostname === 'imagagrant.com' || hostname === 'www.imagagrant.com') ||
  (isAzureStaticApps && !isStaging && hostname.includes('green-desert-06107ed1e'));
const isDev = isAzureStaticApps && !isProduction && !isStaging;

// Legacy API_BASE for backward compatibility
// Use API_ENDPOINTS from apiConfig.js for new code
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (isStaging
    ? "https://imagagrant-prod-westus2-api-func-staging.azurewebsites.net/api"
    : isProduction 
      ? "https://imagagrant-prod-westus2-api-func.azurewebsites.net/api"
      : isDev 
        ? "https://gwc-dev-wus2-api-func-fhaaagbncthsfsej.westus2-01.azurewebsites.net/api"
        : "http://localhost:7071/api");

// Export the new multi-endpoint configuration
export { API_ENDPOINTS, pollJobStatus };